import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border py-12">
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          {/* Brand Column */}
          <div>
            <h3 className="text-xl font-bold text-primary mb-4">DocuRapid</h3>
            <p className="text-sm text-muted-foreground">
              Serviciu privat de asistență pentru obținerea rapidă a documentelor oficiale.
            </p>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Informații Legale</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/termeni-si-conditii" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Termeni și Condiții
                </Link>
              </li>
              <li>
                <Link to="/politica-confidentialitate" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Politica GDPR
                </Link>
              </li>
              <li>
                <Link to="/solutionare-litigii" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Soluționare Litigii (SAL/SOL)
                </Link>
              </li>
              <li>
                <Link to="/despre-noi" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Despre Noi
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-border pt-8 mb-8">
          <div className="flex flex-wrap justify-center gap-8 text-sm text-muted-foreground">
            <span>Email: contact@docurapid.ro</span>
            <span>Tel: 0724200361</span>
            <span>Program: L-V 9:00 - 18:00</span>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-border pt-8">
          <p className="text-xs text-muted-foreground text-center mb-4">
            <strong>Disclaimer:</strong> DocuRapid este un serviciu privat de asistență și intermediere. 
            Nu suntem afiliați cu ANCPI sau alte instituții publice românești. 
            Facilităm obținerea documentelor oficiale în numele clienților noștri.
          </p>
          
          {/* ANPC Compliance Link */}
          <div className="flex justify-center items-center mb-4">
            <Link 
              to="/solutionare-litigii"
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              ANPC - SAL / SOL - Soluționare Litigii
            </Link>
          </div>

          <p className="text-sm text-muted-foreground text-center">
            © 2025 CONS COMON FAST SRL (DocuRapid). Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
